import type { QueryClient } from "@tanstack/react-query";

// Which viewer the cache currently belongs to, as a counter per QueryClient. Bumped whenever the session changes
// (sign-in, sign-out), so work that started under one viewer can tell it has finished under another.
const epochs = new WeakMap<QueryClient, number>();

export function viewerEpoch(queryClient: QueryClient): number {
  return epochs.get(queryClient) ?? 0;
}

export function bumpViewerEpoch(queryClient: QueryClient): number {
  const next = viewerEpoch(queryClient) + 1;
  epochs.set(queryClient, next);
  return next;
}
